import classNames from 'classnames'
import { Lock } from 'lucide-react'
import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { FormattedText } from 'src/modules/core/components'
import type { LockedCalendarsCardProps, LockedCalendarsCardVariant } from './locked-calendars-card.interface'
import classes from './locked-calendars-card.module.scss'

const SUMMARY_MESSAGE_IDS: Record<LockedCalendarsCardVariant, string> = {
  sidebar: 'calendars.locked.summary.sidebar',
  settings: 'calendars.locked.summary.settings',
}

export function LockedCalendarsCard({ lockedCount, upgradePath, variant, className }: LockedCalendarsCardProps) {
  return (
    <div
      className={classNames(classes.card, classes[variant], className)}
      data-testid={`locked-calendars-card-${variant}`}
    >
      {variant === 'settings' && (
        <span className={classes.iconBox}>
          <Lock className={classes.iconBoxLock} aria-hidden="true" />
        </span>
      )}
      <p className={classes.summary}>
        <FormattedText
          id={SUMMARY_MESSAGE_IDS[variant]}
          values={{ count: lockedCount, strong: (chunks: ReactNode) => <strong>{chunks}</strong> }}
        />
      </p>
      <Link to={upgradePath} className={classes.unlockButton}>
        <Lock className={classes.buttonLock} aria-hidden="true" />
        <FormattedText id="calendars.locked.unlockButton" />
      </Link>
    </div>
  )
}
